"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButtonContainerStyled = exports.ArrowBackIconStyled = exports.BackgroundContainerStyled = exports.FormContentStyled = exports.FormContainerStyled = exports.ContentStyled = exports.ContainerStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ArrowBack_1 = __importDefault(require("@material-ui/icons/ArrowBack"));
exports.ContainerStyled = styled_components_1.default.div `
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
`;
exports.ContentStyled = styled_components_1.default.div `
  display: flex;
  flex: 1;
  background: ${({ theme }) => theme.palette.common.white};
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 15px;
  }
`;
exports.FormContainerStyled = styled_components_1.default.div `
  min-width: 45%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex: 1;
  }
`;
exports.FormContentStyled = styled_components_1.default.div `
  display: flex;
  flex: 1;
  ${({ formJustifyContent }) => formJustifyContent &&
    styled_components_1.css `
      justify-content: ${formJustifyContent};
    `}
  ${({ formAlignItems }) => formAlignItems &&
    styled_components_1.css `
      align-items: ${formAlignItems};
    `}
  ${({ theme }) => theme.breakpoints.down('sm')} {
    ${({ formJustifyContentMobile }) => formJustifyContentMobile &&
    styled_components_1.css `
        justify-content: ${formJustifyContentMobile};
      `}
    ${({ formAlignItemsMobile }) => formAlignItemsMobile &&
    styled_components_1.css `
        align-items: ${formAlignItemsMobile};
      `}
  }
`;
exports.BackgroundContainerStyled = styled_components_1.default.div `
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.palette.primary.main};
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;
exports.ArrowBackIconStyled = styled_components_1.default(ArrowBack_1.default) `
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 32px;
`;
exports.BackButtonContainerStyled = styled_components_1.default.div `
  padding: 30px;
  position: absolute;
  left: 0px;
  top: 0px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map